import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateEducationalGroup($data: CreateEducationalGroupInput!) {
    createEducationalGroup(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createEducationalGroup: {
    id: number;
  };
}
